import api from './api';

const userAvailabilityService = {
  checkUsername: async (username, excludeUserId = null, excludePatientId = null) => {
    const params = { username };
    if (excludeUserId) params.excludeUserId = excludeUserId;
    if (excludePatientId) params.excludePatientId = excludePatientId;
    return api.get('/users/check-username', { params });
  },

  checkEmail: async (email, excludeUserId = null, excludePatientId = null) => {
    const params = { email };
    if (excludeUserId) params.excludeUserId = excludeUserId;
    if (excludePatientId) params.excludePatientId = excludePatientId;
    return api.get('/users/check-email', { params });
  },

  checkSsn: async (ssn, excludePatientId = null, excludeUserId = null) => {
    const params = { ssn };
    if (excludePatientId) params.excludePatientId = excludePatientId;
    if (excludeUserId) params.excludeUserId = excludeUserId;
    return api.get('/users/check-ssn', { params });
  },
};

export default userAvailabilityService;
